import { inject, Injectable } from '@angular/core';
import { CanActivate, GuardResult, Router } from '@angular/router';
import { AuthService } from '../services';
import { LeadershipService } from '../services/leadership.service';

@Injectable({ providedIn: 'root' })
export class OrganizationAccessGuard implements CanActivate {
	private readonly authService = inject(AuthService);
	private readonly leadership = inject(LeadershipService);
	private readonly router = inject(Router);

	canActivate(): GuardResult {
		if (this.authService.user && this.leadership.canAccessOrganizations()) {
			return true;
		}

		return this.router.createUrlTree(['/analysis']);
	}
}
